module.exports = __webpack_public_path__ + "img/mind_mapping.8519884d.jpg";